<template>
  <div class="prediction">
    <div class="title">{{ $t('AI智能预测') }}</div>
    <div class="prediction_grid app_card">
      <div class="grid_item">
        <div class="grid_item_label">{{ $t('昨日佣金') }}</div>
        <div class="grid_item_money">{{ moneys.yesterday_commission }}</div>
      </div>
      <div class="grid_item">
        <div class="grid_item_label">{{ $t('本周佣金') }}</div>
        <div class="grid_item_money">{{ moneys.week_commission }}</div>
      </div>
      <div class="grid_item">
        <div class="grid_item_label">{{ $t('平台总佣金') }}</div>
        <div class="grid_item_money">{{ moneys.total_commission }}</div>
      </div>
    </div>
    <div class="selects">
      <div class="selects_item" @click="select1open = true">
        <div class="_title">{{ $t(select1[select1Num].title) }}</div>
        <van-icon name="arrow-down" size="13" color="#111827" />
      </div>
      <div class="selects_item" @click="select2open = true">
        <div class="_title">{{ $t(select2[select2Num].title) }}</div>
        <van-icon name="arrow-down" size="13" color="#111827" />
      </div>
    </div>
    <div class="list app_card">
      <div class="list_top">
        <div class="list_top_title">{{ $t('AI计划预测') }}</div>
        <span>{{ $t('AI方案', { _num: listArr?.length, type: configs && configs?.title, __: '0.00%' }) }}</span>
      </div>
      <template v-if="listArr?.length">
        <div class="lists">
          <div class="list_item" v-for="item, index in listArr" :key="index" @click="itemClick(item)">
            <div class="plan_top">
              <div class="plan_top_left">
                <div class="_name">{{ item.title }}</div>
                <div class="_status">{{ getStatus(item.status, item.is_win) }}</div>
              </div>
              <div class="plan_top_right" v-if="item.hits_num">{{ $t('连中', { __: item.hits_num }) }}</div>
              <div class="plan_top_right" v-else-if="item.losses_num">{{ $t('连跌', { __: item.losses_num }) }}</div>
            </div>
            <div class="plan_cont">
              <div class="plan_cont_left">
                <div class="_item">
                  <div class="_item_title">{{ $t('连胜连败') }}</div>
                  <div class="_item_value" v-if="item.hits_num">
                    {{ $t('连中', { __: item.hits_num }) }}
                  </div>
                  <div class="_item_value" v-if="item.losses_num">
                    {{ $t('连中', { __: item.losses_num }) }}
                  </div>
                </div>
                <div class="_item">
                  <div class="_item_title">{{ $t('投注金额') }}</div>
                  <div class="_item_value">{{ $money(item.cycle_betmoney || '0.00') }}</div>
                </div>
                <div class="_item">
                  <div class="_item_title">{{ $t('奖金金额') }}</div>
                  <div class="_item_value">{{ $money(item.cycle_winmoney || '0.00') }}</div>
                </div>
                <div class="_item">
                  <div class="_item_title">{{ $t('累计利润') }}</div>
                  <div class="_item_value"
                    :class="Number(item?.cycle_winmoney) - Number(item?.cycle_betmoney) < 0 ? 'is_red' : 'is_green'">{{
                      $money((Number(item?.cycle_winmoney) -
                        Number(item?.cycle_betmoney)).toFixed(2)) }}</div>
                </div>
                <div class="_item">
                  <div class="_item_title">{{ $t('代理佣金') }}</div>
                  <div class="_item_value is_green">{{
                    $money(item.cycle_rebate || '0.00') }}</div>
                </div>
              </div>
              <div class="plan_cont_btn">
                <div class="btn" @click.stop="followBet(item)" v-if="item.is_followed != 1">{{ $t('跟投') }}</div>
                <div class="btn" v-else>{{ $t('已跟投') }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no_data">
          <img src="@/assets/Img/null/null.png" alt="">
          <span>{{ $t('Hint.noData') }}</span>
        </div>
      </template>
    </div>
    <van-popup class="menu_popup" v-model="select1open" position="bottom" @click.stop="select1open = false">
      <div class="menu" @click.stop>
        <div class="menu_list" :class="select1Num == index ? 'menu_active' : ''" v-for="item, index in select1"
          :key="index" @click="pop1ItemClick(item, index)">{{ $t(item.title)
          }}
        </div>
      </div>
    </van-popup>
    <van-popup class="menu_popup" v-model="select2open" position="bottom" @click.stop="select2open = false">
      <div class="menu" @click.stop>
        <div class="menu_list" :class="select2Num == index ? 'menu_active' : ''" v-for="item, index in select2"
          :key="index" @click="pop2ItemClick(item, index)">{{ $t(item.title)
          }}
        </div>
      </div>
    </van-popup>
    <aiPop ref="aipopRef" :type="configs.type" />
  </div>
</template>
<script>
import { Icon, Popup, Toast } from "vant";
import { AI_SYSTEM_PLANS } from "@/api";
import aiPop from "./components/pop";
export default {
  components: {
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    Toast,
    aiPop
  },
  props: {
    configs: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      select1: [{
        title: '全部计划',
        value: ''
      }, {
        title: '进行中计划',
        value: 1
      }],
      select1Num: 0,
      select2: [{
        title: '连中榜',
        value: 'hits_num'
      }, {
        title: '赢钱榜',
        value: 'profit'
      }, {
        title: '按最新',
        value: 'id'
      }],
      select2Num: 0,
      select1open: false,
      select2open: false,
      listArr: [],
      moneys: {
        yesterday_commission: '0.00',
        week_commission: '0.00',
        total_commission: '0.00',
      }
    }
  },
  watch: {
    configs(newval) {
      newval?.type && this.getOrder();
    }
  },
  created() {
    this.configs?.type && this.getOrder();
  },
  methods: {
    getStatus(_status, _win) {
      switch (_status) {
        case 0:
          return this.$t('计划取消');
          break;
        case 1:
          // if (Number(_win) > 0) {
          //   return this.$t('计划暂停');
          // }
          return this.$t('进行中');
          break;
        default:
          break;
      }
    },
    itemClick(_item) {
      this.$router.push(`/aiDetail?id=${_item.id}`)
    },
    pop1ItemClick(item, index) {
      if (this.select1Num != index) {
        this.select1Num = index;
        this.$nextTick(() => {
          this.getOrder();
        })
      }
      this.select1open = false;
    },
    pop2ItemClick(item, index) {
      if (this.select2Num != index) {
        this.select2Num = index;
        this.$nextTick(() => {
          this.getOrder();
        })
      }
      this.select2open = false;
    },
    followBet(_item) {
      this.$refs.aipopRef.open({
        title: _item?.title,
        pid: _item?.id,
        status: _item.status,
        steps: _item?.content,
        stop_rules: _item?.stop_rules,
        id: 0,
        lottery_type: _item.last_lottery_type
      })
    },
    async getOrder() {
      try {
        const { data: { lists, total_commission, week_commission, yesterday_commission } } = await AI_SYSTEM_PLANS({ lottery_type: this.configs.type, status: this.select1[this.select1Num].value, sort: this.select2[this.select2Num].value });
        this.listArr = lists;
        this.moneys = { total_commission, week_commission, yesterday_commission }
      } catch {

      }
    }
  }
}
</script>
<style lang="less" scoped>
.prediction {
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .title {
    color: var(--text-color);
    font-size: 16px;
    font-weight: 600;
  }

  .prediction_grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    .grid_item {
      padding: 14px 10px;
      text-align: center;
      border-right: 1px solid rgba(15, 23, 42, .06);
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      .grid_item_label {
        text-align: center;
        font-size: 13px;
        color: #7b808d;
        min-height: 40px;
      }

      .grid_item_money {
        text-align: center;
        font-size: 15px;
        color: #111827;
        font-weight: 600;
        margin-top: 8px;
      }
    }
  }

  .selects {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    .selects_item {
      height: 38px;
      border: 0;
      border-radius: 999px;
      padding: 0 14px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      background: #fff;
      box-shadow: inset 0 0 0 1px #0f172a14;
      color: #111827;
      font-size: 13px;
    }
  }

  .list {
    padding: 12px;

    .list_top {
      .list_top_title {
        font-size: 18px;
        font-weight: 900;
        color: var(--theme);
      }

      span {
        color: #667085;
        margin-top: 6px;
        font-size: 13px;
      }
    }

    .lists {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .list_item {
        padding: 14px;
        border-radius: 18px;
        border: 1px solid rgba(15, 23, 42, .06);
        background: #fff;
        box-shadow: 0 10px 20px #0f172a0a;
        cursor: pointer;
        transition: transform .18s ease, box-shadow .18s ease;

        .plan_top {
          display: flex;
          justify-content: space-between;
          gap: 12px;

          .plan_top_left {

            ._name {
              color: #111827;
              font-size: 16px;
              font-weight: 600;
            }

            ._status {
              color: #7a8597;
              font-size: 12px;
              margin-top: 5px;
            }
          }

          .plan_top_right {
            color: #ff5f59;
            font-size: 14px;
            font-weight: 600;
          }
        }

        .plan_cont {
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          gap: 12px;

          .plan_cont_left {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px 12px;

            ._item {
              ._item_title {
                color: #7a8597;
                font-size: 12px;
                font-weight: 600;
                line-height: 1.2;
              }

              ._item_value {
                color: #111827;
                font-size: 15px;
                margin-top: 6px;
                line-height: 1;
                font-weight: 600;
              }
            }
          }

          .plan_cont_btn {
            .btn {
              background: linear-gradient(90deg, #8ff5d1, #0cc183);
              color: #064b38;
              box-shadow: 0 9px 20px #31e2a547;
              height: 34px;
              font-size: 12px;
              font-weight: 600;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              padding: 0 14px;
              border-radius: 999px;
            }
          }
        }
      }
    }

    .no_data {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;

      img {
        width: 160px;
        height: 160px;
        display: block;
      }

      span {
        color: #969799;
        font-size: 14px;
      }
    }
  }


  .menu_popup {
    border-radius: 10px 10px 0 0;

    .menu {
      margin: 0 auto;
      overflow: hidden;

      .menu_list {
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        color: #323233;
        text-align: center;
        font-size: calc(14rem / 16);
      }

      .menu_active {
        background: var(--btn_bg);
        color: var(--light);
      }
    }
  }

  .is_red {
    color: #e84f62 !important;
  }

  .is_green {
    color: #0cc183 !important;
  }
}
</style>